/**
 * 判断 beforeModal pause 结果是否应视为错误并 reject。
 * @param v - pause 回调传入的结果
 * @param isError - pause 时显式标记的错误标志
 * @returns 是否为错误结果
 */
function isBeforeModalPauseError(v: any, isError: boolean): boolean {
  if (v === 'cancel' || v instanceof Error || isError) {
    return true;
  }
  if (v && v.head) {
    if (v.head.status && v.head.status !== 'Y') return true;
    if (v.head.code && v.head.code !== '00000000') return true;
  }
  if (v && v.success === false) return true;
  return false;
}

export {
  isBeforeModalPauseError,
};
